import React from 'react';
import { motion } from 'framer-motion';
const disciplines = ['Tarot', 'Reiki', 'Registros Akáshicos', 'Péndulo', 'Biodecodificación', 'Constelaciones Familiares', 'Chakras', 'Feng Shui', 'Limpiezas Energéticas', 'Numerología', 'Oráculos', 'Aromaterapia', 'Flores de Bach', 'Radiestesia', 'Runas', 'Sanación de Útero', 'y mucho más...'];
export function ValueSection() {
  return <section className="py-12 bg-white border-t border-gray-100" data-id="element-247">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-248">
        <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-249">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-2xl md:text-4xl font-serif font-bold text-black mb-4" data-id="element-250">
            Todo lo que buscabas, en una sola descarga
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-base text-gray-600 leading-relaxed" data-id="element-251">
            Dejá de pagar cursos por separado o perder horas buscando
            información suelta. Este pack reúne en un solo lugar los temas
            holísticos más buscados, organizados para aprender, aplicar y
            profundizar desde el primer día.
          </motion.p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 md:gap-3" data-id="element-252">
          {disciplines.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.03
        }} className={`px-4 py-2 md:px-6 md:py-3 rounded-full text-sm md:text-base font-medium border
                ${item === 'y mucho más...' ? 'bg-terracotta text-white border-terracotta' : 'bg-white text-gray-800 border-gray-200 shadow-sm'}`} data-id="element-253">
              {item}
            </motion.div>)}
        </div>
      </div>
    </section>;
}